import { Injectable } from '@angular/core';
import { CompanyDto } from 'src/portal/company-api/models/company-dto';
import { CompanyService } from 'src/portal/company-api/services/company.service';
import { ProfileDto } from 'src/portal/user-profile-api/models/profile-dto';
import { UserProfileService } from 'src/portal/user-profile-api/services/user-profile.service';
import {OAuthService} from 'angular-oauth2-oidc';
@Injectable({
  providedIn: 'root'
})
export class UserProfileDataService {

  public userProfileData:ProfileDto = null;
  public userCompanyData:CompanyDto = null;
  private dataLoaded = false;


  constructor(
    private userProfileService:UserProfileService,
    private companyService: CompanyService,
    private oauthService:OAuthService) {
  }

  public async getUserData(refresh = false){
    if(this.oauthService.hasValidAccessToken()){
      if(!this.dataLoaded || refresh){
        this.userProfileData = await this.loadUserProfile();
        if(this.userProfileData?.company?.companyId){
          this.userCompanyData = await this.loadUserCompany(this.userProfileData?.company?.companyId);
        }

        this.dataLoaded = true;
      }
    }
  }

  private loadUserProfile():Promise<ProfileDto>{

      return this.userProfileService.getUserProfile().toPromise();
  }

  private async loadUserCompany(companyId):Promise<CompanyDto>{
    return this.companyService.loadCompany({ id: companyId }).toPromise();
  }
}
